function buildURL() {
  return `${process.env.WEBSOCKET_URL}?token=${localStorage.authentication}`;
}

export default {
  buildURL
};



// WEBPACK FOOTER //
// ./src/utils/actionCable.js